<p-confirmdialog>
  <ng-template #headless let-message let-onAccept="onAccept" let-onReject="onReject">
    <div class="relative flex flex-col items-center rounded-lg bg-white p-6 w-[420px] max-w-[90vw]">
      <div
        class="absolute left-1/2 top-[-34px] inline-flex h-[64px] w-[64px] -translate-x-1/2 items-center justify-center rounded-full text-white"
        [ngClass]="getIconContainerClass(message)"
      >
        <i [class]="getIconClass(message)" class="text-xl"></i>
      </div>
      <span class="mt-6 block text-lg font-semibold text-neutral-900 text-center">
        {{ message.header }}
      </span>
      <p class="mt-2 text-sm text-neutral-600 text-center">
        {{ message.message }}
      </p>
      <div class="flex items-center gap-2 mt-6">
        <p-button
          (click)="onReject()"
          [label]="getRejectLabel(message)"
          severity="secondary"
          size="small"
          [styleClass]="message.rejectButtonStyleClass || ''"
        />
        <p-button
          size="small"
          (click)="onAccept()"
          [label]="getAcceptLabel(message)"
          [styleClass]="message.acceptButtonStyleClass || ''"
        />
      </div>
    </div>
  </ng-template>
</p-confirmdialog>
